import React from 'react'
import axios from "axios";
import {
    URL,
    getAuthorizationHeader,
    idEmpresa
} from "../../constans/constants";
import { logout } from "../login/SesionService"

class AsignarColaboradoresGrupos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cedulaIdentidad: "",
            errors: null,
            datosUsuario: null,
        }
    }


    obtenerUsuario = () => {
        if (this.state.cedulaIdentidad == "") {
            this.setState({ error: "Debe ingresar un numero de cedula" })
        } else {
            axios
                .get(URL + "usuario/obtenerDatosColaborador/" + this.state.cedulaIdentidad, getAuthorizationHeader())
                .then((res) => {
                    if (!res.data.error) {
                        this.setState({ datosUsuario: res.data.datos })
                    } else {
                        this.setState({ error: "Usuario no encontrado" })
                    }
                }, error => {
                    if (error.response.status === 401) {
                        logout();
                    }
                    return error;
                });
        }
    }


    handleClickAgregar = () => {
        this.obtenerUsuario()
    }


    handleConfirmar = () => {
        if (this.state.datosUsuario && this.props.onConfirmar) {
            this.props.onConfirmar(this.state.datosUsuario);
        }
    };

    handleClickEliminar = () => {
        this.setState({ datosUsuario: null, cedulaIdentidad: "" })
    }

    handleInput = (e) => {
        let name = e.target.name;
        let val = e.target.value;
        this.setState({ [name]: val })
    };

    render() {
        return (
            <div className="wrapperContent">
                <div className="page-container">
                    <div className="form">

                        <h5 className="form-midtitle">
                            Defina a qué colaborador asignar el documento
                        </h5>

                        <div className="form-group__inline custom-w">
                            <div className="form-group">
                                <input type="text" name="cedulaIdentidad" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.cedulaIdentidad} />
                                <label htmlFor="nombre" className="form-label"> CI del Colaborador </label>
                            </div>
                            <button onClick={this.handleClickAgregar} className="btn-small btn-primary btn-circle-icon">
                                <span className="material-symbols-outlined"> person_add </span>
                            </button>
                        </div>
                    </div>
                    {
                        this.state.datosUsuario &&
                        <div>
                            <div className="component-table">
                                <div className="responsive-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Cedula de identidad</th>
                                                <th>Nombre Completo</th>
                                                <th>Usuario</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{this.state.datosUsuario.cedula}</td>
                                                <td>{this.state.datosUsuario.nombreApellido}</td>
                                                <td>{this.state.datosUsuario.usuario}</td>
                                                <td>
                                                    <div className="table-actions">
                                                        <button onClick={this.handleClickEliminar} id="deleterow" className="table-icon">
                                                            <span className="material-symbols-outlined"> delete </span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="actions">
                                <button onClick={this.handleConfirmar} className="btn-medium btn-primary" disabled={!this.state.datosUsuario}> Confirmar </button>
                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}

export default AsignarColaboradoresGrupos;